import { render } from "./pendingDetail.vue?vue&type=template&id=948836b0&scoped=true"
import script from "./pendingDetail.vue?vue&type=script&lang=js"
export * from "./pendingDetail.vue?vue&type=script&lang=js"

import "./pendingDetail.vue?vue&type=style&index=0&id=948836b0&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948836b0"]])

export default __exports__